import DOMPurify from "dompurify";

// 관리자(react-quill)가 작성한 공지/가이드 HTML을 렌더링 직전에 정제한다.
// script/이벤트 핸들러 등 위험 태그·속성을 제거해 저장형 XSS를 막는다.
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "p", "br", "strong", "em", "u", "s", "a", "ul", "ol", "li",
      "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "code", "pre",
      "img", "span", "div", "table", "thead", "tbody", "tr", "th", "td",
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "src", "alt", "class", "style"],
  });
}
